export default __webpack_public_path__ + "static/media/bg-bluelines.c74be01a.jpg";